// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a5b71f5f","455":"3482bd29","977":"38a2a902"}[chunkId] + ".chunk.js";
};